import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-cashback',
  standalone: true,
  templateUrl: '../../assets/cashback.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCashbackIcon {}
